import { BaseContainerModel } from '../base-container.model';

import {
  bl_pgw_merchant_rate_event_RowClass,
  bl_pgw_merchant_rate_event_RowInterface
} from '../../dbschema';

export class RateEventContainerModel extends BaseContainerModel {
  bl_pgw_merchant_rate_event: bl_pgw_merchant_rate_event_RowInterface = new bl_pgw_merchant_rate_event_RowClass();
}
